import { sha256 } from "js-sha256"
import moment from "moment"

const API_SECRET = "22aad97e049ac4e16fferwdfsasff"

/**
 * 接口签名生成函数
 * 后端负责人 @vinsonmeng
 */
export function genSecret() {
  const nonce = Math.floor(Math.random() * 10 ** 10) // 十位任意整数
  const timestamp = moment().unix()
  const signature = sha256.hmac(
    API_SECRET,
    `nonce=${nonce}&timestamp=${timestamp}`,
  )
  const secret = `nonce=${nonce}&timestamp=${timestamp}&signature=${signature}`
  return secret
}

export function isDev() {
  return process.env.NODE_ENV === "development"
}
